import { GetCurrentUserPayload, User } from './types';

import { FailureActionPayload } from '../errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const getCurrentUser = createAsyncAction(
  'user/GET_CURRENT_REQUEST',
  'user/GET_CURRENT_RESPONSE',
  'user/GET_CURRENT_FAILURE',
)<GetCurrentUserPayload, { user: User }, FailureActionPayload>();
